import { render, staticRenderFns } from "./informacao.vue?vue&type=template&id=af143e02"
import script from "./informacao.vue?vue&type=script&lang=js"
export * from "./informacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports